module.exports = __webpack_public_path__ + "static/media/age-profile.24ab8e5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/age-profile.png
// module id = 1274
// module chunks = 0